//import RichTextFormEditor from "components/elements/editor/RichTextFormEditor";
import SellPriceLevelSelect from "@components/elements/SellPriceLevelSelect";
import { ActionIcon, SimpleGrid, Table, Textarea } from "@mantine/core";
import { IconMail } from "@tabler/icons-react";
import { formatDate } from "common/utils";
import { CustomInput } from "pages/admin/components/CustomInput";
import { CustomNumberInput } from "pages/admin/components/CustomNumberInput2";
import { FormTableLayout } from "pages/admin/components/FormatTableLayout";
import React from "react";
import { DebtorManagementChildFormProps } from "types/interface.types";

const CustomerDetailsCard2: React.FC<DebtorManagementChildFormProps> = ({
  readonly,
  formApi,
}) => {
  const { values, setFieldValue } = formApi;

  return (
    <div className="card-container ">
      <FormTableLayout>
        <Table.Tbody>
          <Table.Tr>
            <Table.Td>
              <CustomInput
                readonlyMode={readonly}
                label="Postal Address"
                value={values.addressLine1}
                onChange={(v) => setFieldValue("addressLine1", v)}
              />
            </Table.Td>
            <Table.Td>
              <CustomInput
                readonlyMode={readonly}
                label="Delivery Address"
                value={values.deliveryAddressLine1}
                onChange={(v) => setFieldValue("deliveryAddressLine1", v)}
              />
            </Table.Td>
          </Table.Tr>
          <Table.Tr>
            <Table.Td>
              <CustomInput
                readonlyMode={readonly}
                value={values.addressLine2}
                onChange={(v) => setFieldValue("addressLine2", v)}
              />
            </Table.Td>
            <Table.Td>
              <CustomInput
                readonlyMode={readonly}
                value={values.deliveryAddressLine2}
                onChange={(v) => setFieldValue("deliveryAddressLine2", v)}
              />
            </Table.Td>
          </Table.Tr>
          <Table.Tr>
            <Table.Td>
              <Textarea
                readOnly={readonly}
                value={values.addressLine3}
                rows={2}
                styles={{
                  input: {
                    backgroundColor: readonly ? "#f5f5f5" : "white",
                    borderColor: readonly ? "#d0d0d0" : "#228be6",
                    cursor: readonly ? "default" : "text",
                  },
                }}
                onChange={(v) =>
                  setFieldValue("addressLine3", v.currentTarget.value)
                }
              />
            </Table.Td>
            <Table.Td>
              <Textarea
                readOnly={readonly}
                value={values.deliveryAddressLine3}
                rows={2}
                styles={{
                  input: {
                    backgroundColor: readonly ? "#f5f5f5" : "white",
                    borderColor: readonly ? "#d0d0d0" : "#228be6",
                    cursor: readonly ? "default" : "text",
                  },
                }}
                onChange={(v) =>
                  setFieldValue("deliveryAddressLine3", v.currentTarget.value)
                }
              />
            </Table.Td>
          </Table.Tr>
          <Table.Tr>
            <Table.Td colSpan={2}>
              <SimpleGrid cols={3} spacing="md">
                <CustomInput
                  readonlyMode={readonly}
                  label="Phone"
                  value={values.phone}
                  onChange={(v) => setFieldValue("phone", v)}
                />
                <CustomInput
                  readonlyMode={readonly}
                  label="Fax"
                  value={values.faxNumber}
                  onChange={(v) => setFieldValue("faxNumber", v)}
                />
                <CustomInput
                  readonlyMode={readonly}
                  label="Mobile"
                  value={values.mob}
                  onChange={(v) => setFieldValue("mob", v)}
                />
              </SimpleGrid>
            </Table.Td>
          </Table.Tr>
          <Table.Tr>
            <Table.Td>
              <CustomInput
                readonlyMode={readonly}
                label="Email"
                value={values.email}
                onChange={(v) => setFieldValue("email", v)}
                rightSection={
                  readonly && values.email ? (
                    <a
                      href={`mailto:${values.email}`}
                      onClick={(e) => e.stopPropagation()} // so it doesn't focus the input
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <ActionIcon variant="subtle" color="blue">
                        <IconMail size={16} />
                      </ActionIcon>
                    </a>
                  ) : null
                }
              />
            </Table.Td>
            <Table.Td>
              <CustomInput
                readonlyMode={readonly}
                label="Statement Email"
                value={values.alternateEmail}
                onChange={(v) => setFieldValue("alternateEmail", v)}
                rightSection={
                  readonly && values.alternateEmail ? (
                    <a
                      href={`mailto:${values.alternateEmail}`}
                      onClick={(e) => e.stopPropagation()} // so it doesn't focus the input
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <ActionIcon variant="subtle" color="blue">
                        <IconMail size={16} />
                      </ActionIcon>
                    </a>
                  ) : null
                }
              />
            </Table.Td>
          </Table.Tr>
          <Table.Tr>
            <Table.Td>
              <CustomNumberInput
                readonlyMode={readonly}
                label="Discount"
                value={values.discount}
                onChange={(v) => setFieldValue("discount", v)}
              />
            </Table.Td>
            <Table.Td>
              <SellPriceLevelSelect
                readonlyMode={readonly}
                label="Sell Price Level"
                value={values.sellPriceLevel}
                onChange={(v) => setFieldValue("sellPriceLevel", v)}
              />
            </Table.Td>
          </Table.Tr>
          <Table.Tr>
            <Table.Td>
              <CustomNumberInput
                readonlyMode={true}
                label="Last Aged"
                value={values.lastAged}
              />
            </Table.Td>
            <Table.Td>
              <CustomInput
                readonlyMode={true}
                label="Last Sale"
                asDate={true}
                value={formatDate(values.lastSale)}
              />
            </Table.Td>
          </Table.Tr>
        </Table.Tbody>
      </FormTableLayout>
    </div>
  );
};
export default React.memo(CustomerDetailsCard2);
